import {
  Button,
  ButtonType,
  SkeletonLoader,
  colors,
  fontSizing,
  fontWeights,
  sizing,
} from '@chillibean/component-library';
import { Icon } from '@iconify/react';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export function AdminHeroBoxLoading() {
  return (
    <SkeletonLoader
      height={220}
      preserveAspectRatio="none"
      style={{ borderRadius: sizing.xsmall, width: '100%' }}
      width={100}
    >
      <rect height={220} rx={0} ry={0} width="100%" x="0" y="0" />
    </SkeletonLoader>
  );
}

export function AdminHeroBox(props) {
  const { button, content = '', disabled = false, header, loading = false, subHeader, icon } = props;

  if (loading) return <AdminHeroBoxLoading />;

  return (
    <HeroBoxContainer
      className={clsx({
        disabled,
      })}
    >
      <HeaderContainer>
        <IconWrapper>
          <Icon color={colors.red.primary} height={64} icon={icon} width={64} />
        </IconWrapper>
        <HeaderWrapper>
          <SubHeader>{subHeader}</SubHeader>
          <Header>{header}</Header>
        </HeaderWrapper>
      </HeaderContainer>
      <ContentContainer>
        <Content>{content}</Content>
      </ContentContainer>
      <ButtonContainer>
        <Button
          disabled={disabled}
          loading={button?.loading}
          onClick={button?.onClick}
          text={button?.text}
          type={ButtonType.PRIMARY}
        />
      </ButtonContainer>
    </HeroBoxContainer>
  );
}

const HeroBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: 1px solid ${colors.black.primary};
  padding: ${sizing.xlarge};
  border-radius: ${sizing.xsmall};

  &.disabled {
    background-color: ${colors.grey.secondary};
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div``;

const HeaderWrapper = styled.div`
  margin-left: ${sizing.large};
`;

const SubHeader = styled.div`
  font-weight: ${fontWeights.normal};
  font-size: ${fontSizing.medium};
  color: ${colors.grey.medium};
  text-transform: uppercase;
  letter-spacing: ${sizing.tiny};
`;

const Header = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizing.xlarge};
  color: ${colors.red.primary};
`;

const ContentContainer = styled.div``;

const Content = styled.div`
  font-weight: ${fontWeights.normal};
  color: ${colors.grey.medium};
`;

const ButtonContainer = styled.div``;

AdminHeroBox.propTypes = {
  button: PropTypes.shape({
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    text: PropTypes.string,
  }).isRequired,
  content: PropTypes.string,
  disabled: PropTypes.bool,
  header: PropTypes.string.isRequired,
  icon: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool,
  subHeader: PropTypes.string.isRequired,
};

export default AdminHeroBox;
